module.exports = __webpack_public_path__ + "img/shopify-limitations-for-e-commerce-img-1.3403fa0a.jpeg";